// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__Y_YH3","title":"card_title__yYhFT","inActive":"card_inActive__5iqyq"};